/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Answeroptions1Inputs */

const en__field_answeroptions1 = /** @type {(inputs: _Field_Answeroptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer options`)
};

/**
* | output |
* | --- |
* | "Answer options" |
*
* @param {_Field_Answeroptions1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_answeroptions1 = /** @type {((inputs?: _Field_Answeroptions1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Answeroptions1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_answeroptions1(inputs)
});
export { _field_answeroptions1 as "_field_answerOptions" }